// extracted by mini-css-extract-plugin
module.exports = {"viewAll":"shared-components-RecommendedWorksPreviewCarousel-RecommendedWorksPreviewCarousel__viewAll--2Qnud"};